import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { useBodyScrollLock } from '@common/hooks/useBodyScrollLock';

const StyledFiltersModalOverlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  background: #00000094;
  opacity: 0;
  transition: opacity 0.5s ease-out;

  ${({ isVisible }) =>
    isVisible &&
    css`
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9998;
      opacity: 1;
    `}
`;

const StyledFiltersModal = styled.div<{ isVisible: boolean; increasedHeight?: boolean }>`
  position: fixed;
  bottom: -999px;
  left: 0;
  right: 0;
  height: ${({ increasedHeight }) => (increasedHeight ? '95%' : 'fit-content')};
  min-height: fit-content;
  z-index: 9999;
  background: #fff;
  opacity: 0;
  overflow: hidden;
  border-radius: 20px 20px 0px 0px;
  transition: bottom 0.5s ease-in-out, height 0.3s ease-in-out;

  ${({ isVisible }) =>
    isVisible &&
    css`
      opacity: 1;
      bottom: 0;
    `};
`;

type ModalProps = {
  isVisible: boolean;
  children: React.ReactNode;
  increasedHeight?: boolean;
};

export const Modal: FC<ModalProps> = ({ children, isVisible, increasedHeight }) => {
  const targetRef = useBodyScrollLock(isVisible);
  return (
    <StyledFiltersModalOverlay isVisible={isVisible}>
      <StyledFiltersModal isVisible={isVisible} ref={targetRef} increasedHeight={increasedHeight}>
        {isVisible && children}
      </StyledFiltersModal>
    </StyledFiltersModalOverlay>
  );
};
